angular.module('bmsApp.geocode').factory('GeocodeSvc', function ($q,
																 CRUDSvc,
																 GEOCODE_API) {

	var self = {
		missingGeocodeCheck: function () {
			return CRUDSvc.get(GEOCODE_API.MISSING_GEOCODE_CHECK);
		},
		getDefaultCentre: function () {
			return CRUDSvc.get(GEOCODE_API.GET_DEFAULT_CENTRE);
		},
		getMissing: function () {
			return CRUDSvc.get(GEOCODE_API.GET_MISSING);
		},
		saveRecord: function (record) {
			return CRUDSvc.post(GEOCODE_API.SAVE_RECORD, record);
		},
		geocodeAddress: function (params) {
			return CRUDSvc.post(GEOCODE_API.GEOCODE_ADDRESS, params);
		}
	};
	return self;

}).constant('GEOCODE_API', {
	MISSING_GEOCODE_CHECK: 'api/geocode/check-missing',
	GET_DEFAULT_CENTRE: 'api/geocode/default-centre',
	GET_MISSING: 'api/geocode/missing',
	SAVE_RECORD: 'api/geocode/save-record',
	GEOCODE_ADDRESS: 'api/geocode/geocode-address'
});
